export const environment = {
    production: false,
    config: {
        appName: 'Primăria Sectorului 4',
        appDescription: 'DEPS Sector 4',
        fromTokenValid:
            'https://auth-core.ps4.ro/api/login',
        tokenKey: 'wpl-ps4-operator-app-token', // this token is used for every request where is needed
        userKey: 'wpl-ps4-operator-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-ps4-operator', // here we find key for predefined local storage for app functionalities
        copyrightText: 'Copyright © Direcția Generală de Evidență a Persoanelor Sector 4 - 2024',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 30,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Succes',
                error: 'Eroare',
                successForm: 'Felicitări!',
            },
            generalMessages: {
                error:
                    'Ne pare rau, dar am întampinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.',
            },
        },
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _TOTAL_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioară',
            },
            oAria: {
                sSortAscending: ': activează pentru a sorta coloana crescător',
                sSortDescending: ': activează pentru a sorta coloana descrescător',
            },
        },
    },
    interop: {
        basePath: 'https://core.deps4.ro/',
        clientId: 5,
        moduleId: 8,
        deps: {
            authorizeShortToken: 'authorization_code/',
            notifications: {
                authNotifications: 'api/cerere/auth-notifications',
            },
            cerere: {
                list: 'api/cerere/list',
                listDT: 'api/cerere/list-dt',
                find: 'api/cerere/find/', // + id
                store: 'api/cerere/store-intern',

                postMessage: 'api/cerere/post-message/', // + id
                rePostMessage: 'api/cerere/re-post-message/', // + id
                updateStatus: 'api/cerere/update-status/', // + id
                updatePriority: 'api/cerere/update-priority/', // + id
                updateAssignee: 'api/cerere/update-asignee/', // + id
                validateCerere: 'api/cerere/validate/', // + id
                invalidateCerere: 'api/cerere/invalidate/', // + id
                anulareCerere: 'api/cerere/anulare/', // + id
                finalizareCerere: 'api/cerere/finalize-cerere/', // + id
                preluarePersonala: 'api/cerere/preluare-cerere/', // + id
                preluareNumarRegistratura: 'api/cerere/generate-reg-number/', // + id

                resetValidareCerere: 'api/cerere/reset/validare/', // id_cerere - PUT
                resetInvalidareCerere: 'api/cerere/reset/invalidare/', // id_cerere - PUT
                resetClasareCerere: 'api/cerere/reset/clasare/', // id_cerere - PUT
                resetInchidereCerere: 'api/cerere/reset/finalizare/', // id_cerere - POST

                downloadDocument: 'api/cerere/download-document/', // + id

                file: {
                    fileUpload: 'api/cerere/upload-file',
                    fileUploadBase64: 'api/cerere/upload-file-base64',
                },
            },
            programari: {
                listDT: 'api/evidenta/programari/list-dt',
                printList: 'api/evidenta/programari/print-list',
                schedule: 'api/evidenta/programari/schedule', // + id locatie activa in payload
            },
            plati: {
                listDT: 'api/evidenta/invoices/list-dt',
                printChitanta: 'api/evidenta/invoices/print-chitanta/', // + id
            },
            publicatii: {
                listDT: 'api/evidenta/publicatii-casatorii/index',
                archive: 'api/evidenta/publicatii-casatorii/archive/', // + year/month
                store: 'api/evidenta/publicatii-casatorii/add',
                update: 'api/evidenta/publicatii-casatorii/edit/',  // + id
                delete: 'api/evidenta/publicatii-casatorii/delete/', // + id
            },
            nomenclatoare: {
                directie: {
                    getDirectii: 'api/nomenclatoare/directie/list',
                    getDirectiiActive: 'api/nomenclatoare/directie/list/active',
                },
                compartiment: {
                    getCompartimente: 'api/nomenclatoare/directie-compartiment/list',
                    getCompartimenteByDirectie:
                        'api/nomenclatoare/directie-compartiment/listByDirectie/',
                    getCompartimenteActive:
                        'api/nomenclatoare/directie-compartiment/list/active',
                    getCompartimenteByDeps: 'api/nomenclatoare/directie-compartiment/listByDirectieDeps',
                },
                user: {
                    getUsers: 'api/nomenclatoare/user/list',
                    getActiveUsersByOrganigrama:
                        'api/nomenclatoare/user/list-users-organigrama',
                    getUsersList: 'api/nomenclatoare/user/list-all-users',
                },
                functiiUser: {
                    list: 'api/nomenclatoare/functie/list',
                    listActive: 'api/nomenclatoare/functie/list/active',
                },
                judet: {
                    list: 'api/nomenclatoare/judet/list',
                    listActive: 'api/nomenclatoare/judet/list/active',
                },
                cerereStatus: {
                    list: 'api/nomenclatoare/cerere-status/list',
                    listDT: 'api/nomenclatoare/cerere-status/list-dt',
                    listActive: 'api/nomenclatoare/cerere-status/list/active',
                    listPublic: 'api/nomenclatoare/cerere-status/list/public',
                    store: 'api/nomenclatoare/cerere-status/store',
                    update: 'api/nomenclatoare/cerere-status/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-status/active/', // + id
                    public: 'api/nomenclatoare/cerere-status/public/', // + id
                    delete: 'api/nomenclatoare/cerere-status/delete/', // + id
                    clearCache: 'api/nomenclatoare/cerere-status/clear-cache',
                    rankList: 'api/nomenclatoare/cerere-status/rank-list',
                },
                cererePriority: {
                    list: 'api/nomenclatoare/cerere-priority/list',
                    listDT: 'api/nomenclatoare/cerere-priority/list-dt',
                    listActive: 'api/nomenclatoare/cerere-priority/list/active',
                    listPublic: 'api/nomenclatoare/cerere-priority/list/public',
                    store: 'api/nomenclatoare/cerere-priority/store',
                    update: 'api/nomenclatoare/cerere-priority/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-priority/active/', // + id
                    public: 'api/nomenclatoare/cerere-priority/public/', // + id
                    delete: 'api/nomenclatoare/cerere-priority/delete/', // + id
                    clearCache: 'api/nomenclatoare/cerere-priority/clear-cache',
                    rankList: 'api/nomenclatoare/cerere-status/rank-list',
                },
                cerereType: {
                    list: 'api/nomenclatoare/cerere-type/list', // + ?compartiment={value}
                    listDT: 'api/nomenclatoare/cerere-type/list-dt',
                    listActive: 'api/nomenclatoare/cerere-type/list/active',
                    listPublic: 'api/nomenclatoare/cerere-type/list/public',
                    store: 'api/nomenclatoare/cerere-type/store',
                    update: 'api/nomenclatoare/cerere-type/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-type/active/', // + id
                    public: 'api/nomenclatoare/cerere-type/public/', // + id
                    delete: 'api/nomenclatoare/cerere-type/delete/', // + id
                    clearCache: 'api/nomenclatoare/cerere-type/clear-cache',
                },
                zileLibere: {
                    list: 'api/nomenclatoare/zile/libere/list',
                    listDT: 'api/nomenclatoare/zile/libere/list-dt',
                    store: 'api/nomenclatoare/zile/libere/store',
                    update: 'api/nomenclatoare/zile/libere/update',  // id in payload
                    delete: 'api/nomenclatoare/zile/libere/delete/', // + id
                },
                locatii: {
                    list: 'api/nomenclatoare/locatii/list',
                    listDT: 'api/nomenclatoare/locatii/list-dt',
                    store: 'api/nomenclatoare/locatii/store',
                    update: 'api/nomenclatoare/locatii/update',  // id in payload
                    delete: 'api/nomenclatoare/locatii/delete/', // + id
                },
                module: {
                    list: 'api/nomenclatoare/module/module/list',
                    listDT: 'api/nomenclatoare/module/module/list-dt',
                    store: 'api/nomenclatoare/module/module/store',
                    update: 'api/nomenclatoare/module/module/update',  // id in payload
                    delete: 'api/nomenclatoare/module/module/delete/', // + id
                    find: 'api/nomenclatoare/module/module/find/', // + id
                    locatiiProgram: 'api/nomenclatoare/module/module/module-locatii-program/', // + id
                    advancedEdit: 'api/nomenclatoare/module/module/module-advanced-edit', // id in payload
                },
                moduleTipProgram: {
                    list: 'api/nomenclatoare/module/tip-program/list',
                    listDT: 'api/nomenclatoare/module/tip-program/list-dt',
                    store: 'api/nomenclatoare/module/tip-program/store',
                    update: 'api/nomenclatoare/module/tip-program/update',  // id in payload
                    delete: 'api/nomenclatoare/module/tip-program/delete/', // + id
                },
                moduleTipProgramActiv: {
                    list: 'api/nomenclatoare/module/tip-program-activ/list',
                    listDT: 'api/nomenclatoare/module/tip-program-activ/list-dt',
                    store: 'api/nomenclatoare/module/tip-program-activ/store',
                    update: 'api/nomenclatoare/module/tip-program-activ/update',  // id in payload
                    delete: 'api/nomenclatoare/module/tip-program-activ/delete/', // + id
                    findByModule: 'api/nomenclatoare/module/tip-program-activ/find-by-module/',  // + id modul
                },
                moduleLocatiiActive: {
                    list: 'api/nomenclatoare/module/locatii-active/list',
                    listDT: 'api/nomenclatoare/module/locatii-active/list-dt',
                    store: 'api/nomenclatoare/module/locatii-active/store',
                    update: 'api/nomenclatoare/module/locatii-active/update',  // id in payload
                    delete: 'api/nomenclatoare/module/locatii-active/delete/', // + id
                    findByModule: 'api/nomenclatoare/module/locatii-active/find-by-module/', // + id modul
                },
                cerereDocumentType: {
                    list: 'api/nomenclatoare/document-types/list',
                    listDT: 'api/nomenclatoare/document-types/list-dt',
                    find: 'api/nomenclatoare/document-types/find/', // + id
                    store: 'api/nomenclatoare/document-types/store',
                    update: 'api/nomenclatoare/document-types/update',  // id in payload
                    delete: 'api/nomenclatoare/document-types/delete/', // + id
                    clearCache: 'api/nomenclatoare/document-types/clear-cache',
                },
                cerereDocumentCategory: {
                    list: 'api/nomenclatoare/document-categories/list',
                    listDT: 'api/nomenclatoare/document-categories/list-dt',
                    find: 'api/nomenclatoare/document-categories/find/', // + id
                    store: 'api/nomenclatoare/document-categories/store',
                    update: 'api/nomenclatoare/document-categories/update',  // id in payload
                    delete: 'api/nomenclatoare/document-categories/delete/', // + id
                    clearCache: 'api/nomenclatoare/document-categories/clear-cache',
                },
                crons: {
                    list: 'api/nomenclatoare/cron/list',
                    listDT: 'api/nomenclatoare/cron/list-dt',
                    listActive: 'api/nomenclatoare/cron/list-active',
                    store: 'api/nomenclatoare/cron/store',
                    update: 'api/nomenclatoare/cron/update',  // id in payload
                    changeStatus: 'api/nomenclatoare/cron/change-status/', // + id
                    delete: 'api/nomenclatoare/cron/delete/', // + id
                },
                configurations: {
                    listDT: 'api/settings/configuration/list-dt',
                    find: 'api/settings/configuration/find/', // + field_key
                    one: 'api/settings/configuration/one/',   // + id
                    store: 'api/settings/configuration/store',
                    update: 'api/settings/configuration/update', // id in payload
                },
                imageType: {
                    list: 'api/nomenclatoare/image-type/list',
                    listDT: 'api/nomenclatoare/image-type/list-dt',
                    find: 'api/nomenclatoare/image-type/find/', // + id
                    store: 'api/nomenclatoare/image-type/store',
                    update: 'api/nomenclatoare/image-type/update',  // id in payload
                    delete: 'api/nomenclatoare/image-type/delete/', // + id
                },
                cerereSabloane: {
                    list: 'api/nomenclatoare/cerere-sabloane/list',
                    listDT: 'api/nomenclatoare/cerere-sabloane/list-dt',
                    listActive: 'api/nomenclatoare/cerere-sabloane/list/active',
                    listPublic: 'api/nomenclatoare/cerere-sabloane/list/public',
                    store: 'api/nomenclatoare/cerere-sabloane/store',
                    update: 'api/nomenclatoare/cerere-sabloane/update',  // id in payload
                    active: 'api/nomenclatoare/cerere-sabloane/active/', // + id
                    public: 'api/nomenclatoare/cerere-sabloane/public/', // + id
                    delete: 'api/nomenclatoare/cerere-sabloane/delete/', // + id
                },
                operatori: {
                    listDT: 'api/nomenclatoare/user/list-module-users',
                    getOperatorPermisiuniList: 'api/settings/operatori/operator-cereri-permissions-list/', // + id
                    updateOperatorPermisiuni: 'api/settings/operatori/update-cereri-permissions/', // + id
                    getOperatorFunctie: 'api/settings/operatori/operator-cereri-functie/', // + user_id
                    updateOperatorFunctie: 'api/settings/operatori/operator-cereri-functie-update/', // user_id, payload {functie_id}
                    getOperatoriByCompartiment: 'api/settings/operatori/operator-compartment-list/', // + id_compartiment
                }
            },
        },
        authCore: {
            basePath: 'https://auth-core.ps4.ro/',
            linkRedirectAuth: 'https://app.ps4.ro/#/aplicatii',
            platform: {
                getUserDetails: 'api/user/1/1', // get user from token and also validate token for operator to autorize actions
                getUserPermissionsAuthLib:
                    'api/client/module/permission/user/getUserPermissionsAuthLib/',
            },
        },
    },
};

/*
 *  To run this proper configuration, please use: ng serve
 */
